import React from 'react';
import { useTranslation } from 'react-i18next';
import { ContentCustom, PageHeader } from '../../../components';
import { IndicatorWrapper } from './IndicatorWrapper';

const Dashboard = () => {
  const { t } = useTranslation();
  return (
    <>
      <PageHeader title={t('dashboards.title')} />
      <ContentCustom>
        <IndicatorWrapper />
      </ContentCustom>
    </>
  );
};

export { Dashboard };
